/**
 * @license
 * Copyright 2026 Clip Team
 * SPDX-License-Identifier: Apache-2.0
 */

export interface ISatellite {
  /**
   * True if the block is a satellite relative to its parent block.
   * A satellite block is a block that is just a visual part of its block
   * but cannot respond to user interaction and cannot exist independently
   * without its parent block.
   */
  satellite: boolean;
}

/**
 * Returns whether the given object is an ISatelliteBlock or not.
 * @param obj The object to decide.
 * @returns True if obj is ISatelliteBlock
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSatellite(obj: any): obj is ISatellite {
  return obj && typeof obj.satellite === 'boolean';
}
